import { axios } from "..";

export interface IInvoiceHistory {
  id?: string;
  meetingId: string;
  contactId: string;
  registrationId?: string;
  type: "Paid" | "Due";
  amount: number;
  currency: string;
  cc?: string;
  ccName?: string;
  invoice?: string;
  invoiceUrl?: string; 
  dateSent?: string;
  sentBy?: string;
}

export interface ISendInvoiceRequest {
  registrationId: string;
  eventId: string;
  invoiceType: "Paid Invoice" | "Due Invoice" | "No Charge Confirmation";
  ccName?: string;
  ccEmail?: string;
  attendeeEmail?: string;
  currency: string;
  pdfPath?: string;
  amount?: number;
  paymentStatus?: string;
  filename?: string;
}

export interface ISaveInvoiceHistoryRequest {
  registrationId: string;
  eventId: string;
  currency: string;
  amount: number;
  paymentStatus: string;
  pdfPath?: string;
  filename?: string;
  ccEmail?: string;
  ccName?: string;
  sentBy?: string;
}

export interface IUpdateInvoiceAmountRequest {
  registrationId: string;
  registrationFee: number;
  amountPaid: number;
  creditApplied?: number;
  ccName?: string;
  ccEmail?: string;
}

export const getInvoiceHistory = async (
  eventId: string,
  registrationId: string
): Promise<IInvoiceHistory[]> => {
  try {
    const params = new URLSearchParams();
    params.append(
      "filter",
      JSON.stringify({
        meetingId: { value: eventId, comparisonType: "EQUAL" },
        registrationId: { value: registrationId, comparisonType: "EQUAL" },
      })
    );
    const response = await axios.Get(`./invoice-history?${params.toString()}`);
    return response.data || [];
  } catch (error: any) {
    return [];
  }
};

export const updateInvoiceAmount = async (
  request: IUpdateInvoiceAmountRequest
): Promise<any> => {
  try {
    const response = await axios.Post("./invoice/update-amount", request);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const sendInvoice = async (
  request: ISendInvoiceRequest
): Promise<any> => {
  try {
    const response = await axios.Post("./invoice/send", request);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const listInvoiceFiles = async (
  personId: string,
  eventId: string
): Promise<Array<{ name: string; path: string; url: string; dateCreated?: string }>> => {
  try {
    const params = new URLSearchParams();
    params.append("personId", personId);
    params.append("eventId", eventId);
    const url = `./invoice/list?${params.toString()}`;
    const response = await axios.Get(url);
    const invoices = response.data?.invoices || [];
    return invoices;
  } catch (error: any) {
    return [];
  }
};

export const saveInvoiceHistory = async (
  request: ISaveInvoiceHistoryRequest
): Promise<any> => {
  try {
    const response = await axios.Post("./invoice/save-history", request);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};
